import { ResizableColumnService } from './../../shared/services/resizable-column.service';
import { EmploymentAgreementService } from 'src/app/data/employment-agreement.service';
import { AgreementTypeEnum } from 'src/app/models/enums/worker-agreement-type-enum';
import { ChangeDetectorRef, AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { auditTime, filter, finalize, first, map, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Messages } from 'src/app/common/enums/messages';
import { Permission } from 'src/app/common/enums/permissions';
import { download } from 'src/app/common/utils/downloadFile';
import { SendAgreementExtensionConsentRequest } from 'src/app/contracts/requests/send-agreement-extension-consent-request';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { DownloadService } from 'src/app/data/download.service';
import { WorkerAgreementService } from 'src/app/data/worker-agreement.service';
import { Filter } from 'src/app/models/common/filter';
import { AllWorkerAgreementGridDto } from 'src/app/models/dtos/AllWorkerAgreementGridDto';
import { EmploymentType } from 'src/app/models/enums/employment-type-enum';
import { WorkerAgreementStatusEnum } from 'src/app/models/enums/worker-agreement-status-enum';
import { WorkerFormStatusEnum } from 'src/app/models/enums/WorkerFormStatusEnum';
import { WorkerStatusEnum } from 'src/app/models/enums/WorkerStatusEnum';
import { AlertDialogComponent } from 'src/app/shared/messages/alert-dialog/alert-dialog.component';
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { SendMultipleWorkerAgreementsToApprovalSignaturePadComponent } from '../send-multiple-worker-agreements-to-approval-signature-pad/send-multiple-worker-agreements-to-approval-signature-pad.component';
import { AllWorkerAgreementsGridDataSource } from './worker-agreements-list.datasource';
import { isAgreementFileReady } from 'src/app/common/utils/agreement-utils';
import { DatePipe } from '@angular/common';
import { PdfViewerService } from 'src/app/shared/services/pdf-viewer.service';
import { ReportService } from 'src/app/data/report.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { LegalizationService } from 'src/app/data/legalization.service';
import { LegalizationStatusEnum } from 'src/app/models/enums/legalization-status-enum';
import { getKeyByValue } from 'src/app/common/utils/enum-utils';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/messages/confirm-dialog/confirm-dialog.component';
import { MultipleWorkerAgreementsActionConfigDto } from 'src/app/models/dtos/multiple-worker-agreements-action-config-dto';
import { MultipleWorkerAgreementsActionSelectedWorkersDto } from 'src/app/models/dtos/multiple-worker-agreements-action-selected-workers-dto';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TerminateAgreementModalComponent } from 'src/app/worker-agreement-termination/terminate-agreement-modal/terminate-agreement-modal.component';
import { MultipleWorkerAgreementsActionSelectedWorkerAgreementDto } from 'src/app/models/dtos/multiple-worker-agreements-action-selected-worker-agreement-dto';
import { EmploymentConditionsConfirmationStatusEnum } from 'src/app/models/enums/employment-conditions-confirmation-status-enum';
import { ScreenService } from 'src/app/core/screen.service';
import { FilterService } from 'src/app/list-filter/services/filter.service';
import { WorkerAgreementListFilterService } from '../services/worker-agreement-list-filter.service';
import { ModuleName } from 'src/app/subscription-package';
import { HttpErrorResponse } from '@angular/common/http';
import { AnnexService } from 'src/app/data/annex.service';
import { AgreementsInvalidatedEvent, WorkerAgreementsSignalrService } from 'src/app/data/worker-agreements-signalr.service';
import { DEFAULT_REALTIME_REFRESH_THROTTLE_MS } from 'src/app/shared/constants/realtime.constants';
import { SplitComponentService } from 'src/app/split/services/split-component.service';
import { SplitComponentEnum } from 'src/app/common/enums/split-components';
import { WorkerAgreementDetailsPanelComponent } from './worker-agreement-details-panel/worker-agreement-details-panel.component';
import { getExtensionOnMultipleAgreementsAvailability, selectWithoutDuplicates, selectWorkerAgreementsWithoutDuplicates } from '../worker-agreements.utils';

const employmentConditionsConfirmationStatusTranslaionPrefix = 'EmploymentConditionsConfirmationStatus'

@Component({
  selector: 'app-worker-agreements-list',
  templateUrl: './worker-agreements-list.component.html',
  styleUrls: ['./worker-agreements-list.component.scss'],
  providers: [
    DatePipe,
    ResizableColumnService,
    { provide: FilterService, useClass: WorkerAgreementListFilterService },
  ],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1s ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('1s ease-in', style({ opacity: 0 }))
      ])
    ])
  ],
  standalone: false
})
export class WorkerAgreementsListComponent implements OnInit, AfterViewInit, OnDestroy {
  screenService = inject(ScreenService);
  private workerAgreementService = inject(WorkerAgreementService);
  private employmentAgreementService = inject(EmploymentAgreementService);
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);
  private spinner = inject(NgxSpinnerService);
  private downloadService = inject(DownloadService);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private snackbarService = inject(SnackBarService);
  private pdfViewerService = inject(PdfViewerService);
  private reportService = inject(ReportService);
  datepipe = inject(DatePipe);
  private legalizationService = inject(LegalizationService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private resizableColumnService = inject(ResizableColumnService);
  private filterService = inject(FilterService);
  private annexService = inject(AnnexService);
  private agreementsSignalR = inject(WorkerAgreementsSignalrService);
  private splitComponentService = inject(SplitComponentService);
  private route = inject(ActivatedRoute);

  splitComponentId = 'worker-agreements-list-split';

  sticky = false;
  @ViewChild(CdkVirtualScrollViewport, { static: true }) viewport: CdkVirtualScrollViewport;
  @ViewChild('tableContainer', { static: true }) tableContainerRef: ElementRef;

  public readonly moduleNames = ModuleName;

  resizableColumnDefinitions =
    [
      { column: 'Company', width: 220, minWidth: 220 },
      { column: 'EmployerName', width: 220, minWidth: 220 },
      { column: 'EmployerObject', width: 220, minWidth: 220 },
      { column: 'JobTitle', width: 220, minWidth: 220 },
      { column: 'AgreementStatus', width: 160, minWidth: 160 },
    ]

  tableMinWidth = 2565;
  visibleColumns: any[];

  page = 1;
  pageSize = 30;
  offset$: Observable<number>;

  WorkerAgreementStatusEnum = WorkerAgreementStatusEnum;
  WorkerStatusEnum = WorkerStatusEnum;

  filtersFormGroup: UntypedFormGroup;
  displayedColumns: string[] = [
    'select',
    'LastName',
    'WorkerStatus',
    'WorkerFormStatus',
    'Company',
    'EmployerName',
    'EmployerObject',
    'EmploymentType',
    'AgreementType',
    'JobTitle',
    'AgreementStartDate',
    'AgreementEndEffectiveDate',
    'AgreementConclusionDate',
    'AgreementStatus',
    'Actions'
  ];

  isAdmin: boolean = false;
  activeAnnexAgreementId: number | null = null;
  canViewAgreementDetails: boolean = false;

  openAnnexesPanel(element: AllWorkerAgreementGridDto): void {
    if (!this.hasDetailsAccess()) { return; }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { agreementId: element.AgreementId },
      queryParamsHandling: 'merge',
    });
  }

  onAnnexPanelClose(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { agreementId: null },
      queryParamsHandling: 'merge',
    });
  }

  private openAnnexesPanelFromParams(params: Params): void {
    if (!this.hasDetailsAccess()) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          agreementId: null
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });

      return;
    }

    const id = +params['agreementId'];
    if (isNaN(id)) { return; }
    const { prevId, nextId } = this.getAdjacentAgreementIds(id);
    this.splitComponentService.addComponent(this.splitComponentId, {
      id: SplitComponentEnum.WorkerAgreementDetailsPanel,
      componentType: WorkerAgreementDetailsPanelComponent,
      direction: 'horizontal',
      data: {
        workerAgreementId: id,
        isAdmin: this.isAdmin,
      },
      size: 33,
      header: {
        closeButton: true,
        leftButtons: [
          {
            icon: 'keyboard_arrow_up',
            disabled: prevId == null,
            title: this.translateService.instant('AnnexPanel.PrevAgreement'),
            onClick: () => prevId != null && this.router.navigate([], {
              relativeTo: this.route,
              queryParams: { agreementId: prevId },
              queryParamsHandling: 'merge',
            }),
          },
          {
            icon: 'keyboard_arrow_down',
            disabled: nextId == null,
            title: this.translateService.instant('AnnexPanel.NextAgreement'),
            onClick: () => nextId != null && this.router.navigate([], {
              relativeTo: this.route,
              queryParams: { agreementId: nextId },
              queryParamsHandling: 'merge',
            }),
          },
        ],
      },
    });
  }

  private getAdjacentAgreementIds(currentId: number): { prevId: number | null; nextId: number | null } {
    const all = this.dataSource?.allData ?? [];
    const idx = all.findIndex(a => a.AgreementId === currentId);
    if (idx === -1) { return { prevId: null, nextId: null }; }
    return {
      prevId: idx > 0 ? all[idx - 1].AgreementId : null,
      nextId: idx < all.length - 1 ? all[idx + 1].AgreementId : null,
    };
  }

  private _areFiltersExpanded: boolean;
  public get areFiltersExpanded(): boolean {
    return this._areFiltersExpanded;
  }
  public set areFiltersExpanded(value: boolean) {
    if (this._areFiltersExpanded !== value) {
      this._areFiltersExpanded = value;
      this.checkViewportSize();
    }
  }

  dataSource: AllWorkerAgreementsGridDataSource;
  hasLegalization: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public get scrollItemPosition(): number {
    return this.viewport.getRenderedRange().end;
  }

  private multipleActionsConfig: MultipleWorkerAgreementsActionConfigDto;
  extensionAvailability: { enabled: boolean; reasonKey: string } = { enabled: false, reasonKey: 'ActionAvailabilityPending' };
  extensionTooltip: string = '';
  private readonly defaultPage: number = 1;
  private readonly defaultPageSize: number = 1000;
  private readonly selectionLengthWarning: number = 50;
  private readonly defaultSortColumn: string = 'CreatedOn';
  private readonly defaultSortDirection: string = 'desc';
  private readonly notAllowedToEditWorkerAgreementMessage: string = 'NotAllowedToEditWorkerAgreementMessage';
  private readonly employeeIsInLegalizationProcess: string = 'EmployeeIsInLegalizationProcess';
  private readonly unsubscribe$ = new Subject<void>();

  public filters: Filter[] = [];

  public readonly workerAgreementStatusEnum = WorkerAgreementStatusEnum;
  public readonly workerStatusEnum = WorkerStatusEnum;
  public readonly workerFormStatusEnum = WorkerFormStatusEnum;
  public readonly legalizationStatusEnum = LegalizationStatusEnum;
  public readonly employmentConditionsConfirmationStatusEnum = EmploymentConditionsConfirmationStatusEnum;


  constructor() {
    if (this.employmentConditionConfirmationStatusVisible()) {
      let index = this.displayedColumns.findIndex(item => item === 'AgreementStartDate');

      if (index !== -1) {
        this.displayedColumns.splice(index, 0, 'EmploymentConditionsConfirmationStatusId');
      }
    }
  }

  @HostListener('window:resize', ['$event.target'])
  onResize(): void {
    this.resizableColumnService.onResize();
  }

  @HostListener('window:keydown.ArrowLeft', ['$event'])
  @HostListener('window:keydown.ArrowUp', ['$event'])
  onKeyArrowLeft(event: Event): void {
    const tag = ((event as KeyboardEvent).target as HTMLElement)?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') { return; }
    if (this.activeAnnexAgreementId == null) { return; }
    const { prevId } = this.getAdjacentAgreementIds(this.activeAnnexAgreementId);
    if (prevId != null) {
      event.preventDefault();
      this.router.navigate([], { relativeTo: this.route, queryParams: { agreementId: prevId }, queryParamsHandling: 'merge' });
    }
  }

  @HostListener('window:keydown.ArrowRight', ['$event'])
  @HostListener('window:keydown.ArrowDown', ['$event'])
  onKeyArrowRight(event: Event): void {
    const tag = ((event as KeyboardEvent).target as HTMLElement)?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') { return; }
    if (this.activeAnnexAgreementId == null) { return; }
    const { nextId } = this.getAdjacentAgreementIds(this.activeAnnexAgreementId);
    if (nextId != null) {
      event.preventDefault();
      this.router.navigate([], { relativeTo: this.route, queryParams: { agreementId: nextId }, queryParamsHandling: 'merge' });
    }
  }

  employmentConditionConfirmationStatusVisible = () => this.authService.hasPermission(Permission.ViewAllExternalWorkerEmploymentConditionsConfirmation) || this.authService.hasPermission(Permission.ViewMyExternalWorkerEmploymentConditionsConfirmation) || this.authService.isAdmin();

  async ngOnInit(): Promise<void> {
    this.isAdmin = this.authService.isAdmin();
    this.canViewAgreementDetails = this.hasDetailsAccess();
    this.init();

    this.filterService.filters$.subscribe(filters => {
      this.filterData(filters);
    });

    this.fetchData();
    this.initListRefresher();
    this.initLangChanegeObserver();

    this.hasLegalization = await firstValueFrom(this.legalizationService.hasAccessToLegalization());

    this.resizableColumnService.setConfig(this.resizableColumnDefinitions, this.tableMinWidth, this.tableContainerRef, this.changeDetectorRef);
    this.resizeOnDataLoaded();
  }

  private readonly scrollPositionStorageKey = 'worker-agreements-list-scroll-offset';
  private scrollRestored = false;

  ngAfterViewInit(): void {
    this.route.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (params['agreementId'] && this.canViewAgreementDetails) {
        const parsed = +params['agreementId'];
        this.activeAnnexAgreementId = isNaN(parsed) ? null : parsed;
        if (this.activeAnnexAgreementId != null) {
          this.openAnnexesPanelFromParams(params);
        }
      } else {
        this.activeAnnexAgreementId = null;
        this.splitComponentService.removeComponent(this.splitComponentId, SplitComponentEnum.WorkerAgreementDetailsPanel);
      }
    });

    this.dataSource.dataLoaded$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      if (this.activeAnnexAgreementId != null) {
        this.openAnnexesPanelFromParams({ agreementId: this.activeAnnexAgreementId });
      }
      this.restoreScrollPosition();
    });
  }

  ngOnDestroy(): void {
    this.saveScrollPosition();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.agreementsSignalR.disconnect();
  }

  private saveScrollPosition(): void {
    if (!this.viewport) { return; }
    const offset = this.viewport.measureScrollOffset('top');
    if (offset > 0) {
      sessionStorage.setItem(this.scrollPositionStorageKey, String(offset));
    } else {
      sessionStorage.removeItem(this.scrollPositionStorageKey);
    }
  }

  private restoreScrollPosition(): void {
    if (this.scrollRestored) { return; }
    const raw = sessionStorage.getItem(this.scrollPositionStorageKey);
    if (!raw || !this.viewport) { return; }
    const offset = parseInt(raw, 10);
    if (isNaN(offset) || offset <= 0) { return; }
    this.scrollRestored = true;
    sessionStorage.removeItem(this.scrollPositionStorageKey);
    this.progressiveScrollToOffset(offset);
  }

  private progressiveScrollToOffset(target: number, attempt = 0): void {
    if (!this.viewport) { return; }
    const id = setTimeout(() => {
      if (!this.viewport) { return; }
      this.viewport.scrollToOffset(target);
      const current = this.viewport.measureScrollOffset('top');
      if (Math.abs(current - target) < 4 || attempt >= 40) { return; }
      // cdk clamped scroll to current known max; force load next batch and retry
      if (!this.dataSource.isLoading) {
        this.fetchData(++this.page);
      }
      this.progressiveScrollToOffset(target, attempt + 1);
    }, 150) as unknown as number;
    this.unsubscribe$.pipe(first()).subscribe(() => clearTimeout(id));
  }

  hasAnyAction(workerAgreement: AllWorkerAgreementGridDto): boolean {
    return this.isAgreementFileButtonVisible(workerAgreement) ||
      this.isExtendAgreementButtonVisible(workerAgreement.AgreementStatusId, workerAgreement.AgreementTypeId, workerAgreement.EmploymentTypeId) ||
      this.isReplaceAgreementButtonVisible(workerAgreement.AgreementStatusId, workerAgreement.AgreementTypeId) ||
      this.isEditAgreementButtonVisible(workerAgreement.AgreementStatusId) ||
      this.isAddAnnexButtonVisible(workerAgreement.AgreementStatusId) ||
      this.isTerminateButtonVisible(workerAgreement) ||
      this.isDetailsButtonVisible(workerAgreement.AgreementStatusId);
  }
  private employmentConditionsConfirmationStatusClassMap = {
    [EmploymentConditionsConfirmationStatusEnum.Generated]: 'tooltip--pink',
    [EmploymentConditionsConfirmationStatusEnum.Signed]: 'tooltip--blue',
    [EmploymentConditionsConfirmationStatusEnum.Read]: 'tooltip--darkgreen',
    default: '',
  };

  hasEmploymentConditionsConfirmationStatus(employmentConditionsConfirmationStatusEnum: EmploymentConditionsConfirmationStatusEnum, employmentConditionsConfirmationStatusId: number): boolean {
    return employmentConditionsConfirmationStatusId === employmentConditionsConfirmationStatusEnum;
  }

  getEmploymentConditionsConfirmationStatusEnum(employmentConditionsConfirmationStatusId: number): string {
    const key = getKeyByValue(this.employmentConditionsConfirmationStatusEnum, employmentConditionsConfirmationStatusId);
    return `${employmentConditionsConfirmationStatusTranslaionPrefix}.${key}`;
  }

  getEmploymentConditionsConfirmationTooltipClass(employmentConditionsConfirmationStatusId: number): string {
    return this.employmentConditionsConfirmationStatusClassMap[employmentConditionsConfirmationStatusId] || this.employmentConditionsConfirmationStatusClassMap.default;
  }

  isDetailsButtonVisible = (statusId: number): boolean =>
    statusId !== WorkerAgreementStatusEnum.WaitingForGeneration && this.hasDetailsAccess();

  private hasDetailsAccess = (): boolean =>
    this.authService.hasAnyPermission([Permission.ManageMyExternalWorkersList, Permission.ViewAllExternalWorkers]);

  isAgreementFileButtonVisible = (workerAgreement: AllWorkerAgreementGridDto): boolean =>
    isAgreementFileReady(workerAgreement.AgreementStatusId) && !workerAgreement.IsImported &&
    (this.authService.hasAnyPermission([Permission.AgreementPreview, Permission.AgreementPreviewAllExternalWorkers, Permission.AgreementPreviewMyExternalWorkers]));

  async sendAgreementExtensionConsent() {
    const selectedWorkers = await this.getSelectedWorkersList();

    if (selectedWorkers.length <= this.selectionLengthWarning || await this.openConfirmDialog(this.translateService.instant('WL-SendAgreementExtensionConsentConfirmation', { selectionLength: selectedWorkers.length }))) {

      const requests = selectedWorkers.map((sw): SendAgreementExtensionConsentRequest =>
      ({
        WorkerId: sw.Id,
        WorkerFormId: sw.WorkerFormId,
      })
      );

      this.spinner.show();

      this.workerAgreementService
        .sendAgreementExtensionConsent(requests)
        .pipe(
          first(),
          finalize(() => this.spinner.hide()),
        )
        .subscribe((_) => this.snackbarService.openSuccessSnackBar(Messages.SuccessfullySentExtensionConsents));
    }
  }

  onExtendAgreementClick(agreementId: number, workerId: number, employmentTypeId: number) {
    this.spinner.show();

    const action$ =
      employmentTypeId === EmploymentType.MandateAgreement || employmentTypeId === EmploymentType.TemporaryMandateAgreement
        ? this.workerAgreementService.extendWorkerMandateAgreement(agreementId)
        : this.employmentAgreementService.extendEmploymentAgreement(agreementId);

    action$.pipe(
      first(),
      finalize(() => this.spinner.hide()),
    )
      .subscribe((agreementId) =>
        this.router.navigate(['/workers', workerId, 'employmentType', employmentTypeId, 'agreements', agreementId], {
          state: { extension: true },
        }),
      );
  }

  isExtendAgreementButtonVisible = (agreementStatusId: number, agreementTypeId: number, employmentTypeId: number): boolean =>
    (agreementStatusId === WorkerAgreementStatusEnum.Accepted || agreementStatusId === WorkerAgreementStatusEnum.Active) &&
    agreementTypeId !== AgreementTypeEnum.Permanent && this.authService.hasAnyPermission([Permission.ManageAllExternalWorkersList, Permission.ManageMyExternalWorkersList]) &&
    (employmentTypeId === EmploymentType.EmploymentAgreement ||
      employmentTypeId === EmploymentType.TemporaryEmploymentAgreement ||
      employmentTypeId === EmploymentType.MandateAgreement ||
      employmentTypeId === EmploymentType.TemporaryMandateAgreement);

  async replaceAgreement(agreement: AllWorkerAgreementGridDto) {
    let agreementId: number;
    if (agreement.WaitingForGenerateReplacementWorkerAgreementId) {
      agreementId = agreement.WaitingForGenerateReplacementWorkerAgreementId;
    } else {
      this.spinner.show();

      this.workerAgreementService
        .replaceWorkerAgreement(agreement.AgreementId)
        .pipe(
          first(),
          finalize(() => this.spinner.hide()),
        )
        .subscribe((returnedAgreementId) => {
          agreementId = returnedAgreementId;
          this.router.navigate(['/workers', agreement.WorkerId, 'employmentType', agreement.EmploymentTypeId, 'agreements', agreementId])
        })
    }
  }

  isReplaceAgreementButtonVisible = (agreementStatusId: number, employmentTypeId: number): boolean =>
    (agreementStatusId === WorkerAgreementStatusEnum.Accepted || agreementStatusId === WorkerAgreementStatusEnum.Active) &&
    (employmentTypeId === EmploymentType.MandateAgreement || employmentTypeId === EmploymentType.TemporaryMandateAgreement);

  onShowAgreementClick(agreementId: number, firstName: string, lastName: string) {
    this.pdfViewerService.show({
      Endpoint: 'workerAgreements/workerAgreementFile',
      FileId: agreementId,
      FileName: this.setFileName(`${firstName} ${lastName}`),
    });
  }

  onDownloadAgreementClick(agreementId: number, firstName: string, lastName: string) {
    const fileName = this.setFileName(`${firstName} ${lastName}`);
    this.downloadService
      .getFileAsBlob('workerAgreements/workerAgreementFile', agreementId, fileName)
      .subscribe((srcUrl) => download(srcUrl, fileName));
  }

  isEditAgreementButtonVisible = (statusId: number): boolean =>
    (this.authService.hasPermission(Permission.ManageAllExternalWorkersList) ||
      this.authService.hasPermission(Permission.ManageMyExternalWorkersList)) &&
    statusId === WorkerAgreementStatusEnum.WaitingForGeneration;

  onEditAgreementClick(workerAgreement: AllWorkerAgreementGridDto): void {
    if (workerAgreement.WorkerFormStatusId != WorkerFormStatusEnum.Approved) {
      this.openAlertDialog(this.notAllowedToEditWorkerAgreementMessage);
      return;
    }

    if (workerAgreement.AgreementStatusId !== WorkerAgreementStatusEnum.WaitingForGeneration) {
      return;
    }

    this.router.navigate([
      '/workers',
      workerAgreement.WorkerId,
      'employmentType',
      workerAgreement.EmploymentTypeId,
      'agreements',
      workerAgreement.AgreementId,
    ]);
  }

  isAddAnnexButtonVisible = (statusId: number): boolean =>
    this.authService.hasPermission(Permission.CreateAnnex) &&
    (statusId === WorkerAgreementStatusEnum.Accepted || statusId === WorkerAgreementStatusEnum.Active);

  onAddAnnexClick(agreementId: number, workerId: number, employmentTypeId: number): void {
    this.spinner.show();
    this.annexService
      .canCreateAnnex(agreementId)
      .pipe(
        first(),
        finalize(() => this.spinner.hide()),
      )
      .subscribe({
        next: () => {
               this.router.navigate([
                '/workers',
                workerId,
                'employmentType',
                employmentTypeId,
                'agreements',
                agreementId,
                'annex'
              ]);
        },
        error: (error: HttpErrorResponse) => {
          this.snackbarService.openErrorSnackBar(error.error);
        },
      });
  }

  isSendAgreementExtensionConsentButtonEnabled = (): boolean => this.isAllSelected()
    ? this.multipleActionsConfig?.CanSendAgreementsExtensionsConsent
    : this.dataSource.selection.selected.length &&
    this.dataSource.selection.selected.every(
      (v) => v.AgreementStatusId === WorkerAgreementStatusEnum.Accepted || v.AgreementStatusId === WorkerAgreementStatusEnum.Active,
    );

  isTerminateButtonVisible = (workerAgreement: AllWorkerAgreementGridDto): boolean =>
    ((this.authService.authServerUserId == workerAgreement.AuthServerUserId && this.authService.hasPermission(Permission.TerminateMyAgreement)) || this.authService.hasPermission(Permission.TerminateMandateAgreement)) &&
    workerAgreement.AgreementStatusId === WorkerAgreementStatusEnum.Active &&
    (workerAgreement.EmploymentTypeId === EmploymentType.MandateAgreement || workerAgreement.EmploymentTypeId === EmploymentType.TemporaryMandateAgreement) &&
    !workerAgreement.HasAgreementTerminationReason;

  onTerminateClick(
    workerId: number,
    workerFullName: string,
    employer: string,
    agreementId: number,
    noticePeriodId: number,
    employmentDateFrom: Date,
    employmentDateTo: Date,
    employmentTypeId: number,
    hasAgreementTerminationReason: boolean
  ) {
    this.dialog.open(TerminateAgreementModalComponent, {
      data: {
        WorkerId: workerId,
        WorkerFullName: workerFullName,
        Employer: employer,
        WorkerAgreementId: agreementId,
        NoticePeriodId: noticePeriodId,
        EmploymentDateFrom: employmentDateFrom,
        EmploymentDateTo: employmentDateTo,
        EmploymentTypeId: employmentTypeId,
        HasAgreementTerminationReason: hasAgreementTerminationReason
      },
    });
  }

  async filterData(filters: Filter[]): Promise<void> {
    this.filters = filters;
    this.resetData();
    this.fetchData();
    await this.getMultipleActionsConfig();
  }

  onSortChange() {
    this.resetData();
    this.fetchData();
  }

  onRowChxChange(event: MatCheckboxChange, row: AllWorkerAgreementGridDto) {
    if (event) {
      this.dataSource.selection.toggle(row);
      this.refreshExtensionAvailability();
      this.changeDetectorRef.detectChanges();
    }
  }

  toggleFiltersPanel = () => (this.areFiltersExpanded = !this.areFiltersExpanded);

  isAllSelected = () => this.dataSource.isAllSelected;

  async onSelectAllChxChange(): Promise<void> {
    if (this.isAllSelected()) {
      this.dataSource.deselectAll();
      this.refreshExtensionAvailability();
    } else {
      this.dataSource.selectAll();
      await this.getMultipleActionsConfig();
    }
  }

  async resetFilters(): Promise<void> {
    await firstValueFrom(this.filterService.resetFilters());
  }

  isGenerationOnMultipleAgreementsEnabled = () => this.isAllSelected()
    ? this.multipleActionsConfig?.CanGenerateAgreements
    : !!this.dataSource.selection.selected.length &&
    !this.dataSource.selection.selected.some((v, i, a) => a.some((t) => t.EmploymentTypeId !== v.EmploymentTypeId)) &&
    this.dataSource.selection.selected.every((s) => s.WorkerFormStatusId === WorkerFormStatusEnum.Approved
    );

  generateMultipleAgreements = async () => {
    if (!this.isGenerationOnMultipleAgreementsEnabled()) return;

    const selectedWithoutDuplicates = await this.getSelectedWorkersList();

    if (selectedWithoutDuplicates.length <= this.selectionLengthWarning || await this.openConfirmDialog(this.translateService.instant('WL-GenerateMultipleAgreementsConfirmation', { selectionLength: selectedWithoutDuplicates.length }))) {
      const employmentTypeId = this.dataSource.selection.selected[0].EmploymentTypeId;

      this.router.navigate(['/workers', 'multiple', 'employmentType', employmentTypeId, 'agreements'], {
        state: { workers: selectedWithoutDuplicates },
      });
    }
  };

  extendMultipleAgreements = async () => {
    if (!this.extensionAvailability.enabled) return;

    const selectedWithoutDuplicates = await this.getSelectedWorkersList();

    if (selectedWithoutDuplicates.length <= this.selectionLengthWarning || await this.openConfirmDialog(this.translateService.instant('WL-ExtendMultipleAgreementsConfirmation', { selectionLength: selectedWithoutDuplicates.length }))) {
      const employmentTypeId = this.dataSource.selection.selected[0].EmploymentTypeId;
      this.router.navigate(['/workers', 'multiple', 'employmentType', employmentTypeId, 'agreements'], {
        state: { workers: selectedWithoutDuplicates, extension: true },
      });
    }
  };

  isSendingMultipleAgreementsToApprovalEnabled = () => this.isAllSelected()
    ? this.multipleActionsConfig?.CanSendAgreementsToApproval
    : (this.authService.hasPermission(Permission.ManageMyExternalWorkersList) ||
      this.authService.hasPermission(Permission.ManageAllExternalWorkersList)) &&
    this.authService.hasPermission(Permission.SignAgreementAsEmployerRepresentative) &&
    !!this.dataSource.selection.selected.length &&
    !this.dataSource.selection.selected.some((v, i, a) => a.some((t) => t.EmploymentTypeId !== v.EmploymentTypeId)) &&
    this.dataSource.selection.selected.every(
      (s) => s.AgreementStatusId === WorkerAgreementStatusEnum.Generated && s.WorkerStatusId === WorkerStatusEnum.Activated,
    );

  sendMultipleAgreementsToApproval = async () => {
    if (!this.isSendingMultipleAgreementsToApprovalEnabled()) return;

    const refreshData = async () => {
      var { page, pageSize } = this.getActualPage();

      this.fetchData(page, pageSize);
      await this.getMultipleActionsConfig();
    }
    const selectedWorkerAgreement = await this.getSelectedWorkerAgreementsList();

    if (selectedWorkerAgreement.length <= this.selectionLengthWarning || await this.openConfirmDialog(this.translateService.instant('WL-SendMultipleAgreementsToApprovalConfirmation', { selectionLength: selectedWorkerAgreement.length }))) {
      if (this.dataSource.selection.selected[0].EmploymentTypeId == EmploymentType.MandateAgreement || this.dataSource.selection.selected[0].EmploymentTypeId == EmploymentType.TemporaryMandateAgreement) {
        this.spinner.show().then((_) =>
          this.workerAgreementService
            .sendMultipleWorkerAgreementsToApproval({
              WorkerAgreementIds: selectedWorkerAgreement.map(sw => sw.Id),
              EmploymentTypeId: this.dataSource.selection.selected[0].EmploymentTypeId,
              SignatureFileBase64: null,
            })
            .pipe(
              first(),
              finalize(async () => {
                this.spinner.hide();
                this.snackbarService.openSuccessSnackBar(Messages.SuccessfullySentMultipleAgreeemntsToApproval);
                await refreshData();
              }),
            )
            .subscribe(),
        );
      } else {
        this.dialog
          .open(SendMultipleWorkerAgreementsToApprovalSignaturePadComponent, {
            data: {
              WorkerAgreementIds: selectedWorkerAgreement.map(agreement => agreement.Id),
              EmploymentTypeId: this.dataSource.selection.selected[0].EmploymentTypeId,
            },
          })
          .afterClosed()
          .pipe(first())
          .subscribe((isSuccess) => isSuccess && refreshData());
      }
    }
  };

  isAnyWorkeAgreemetnSelected() {
    return this.isAllSelected() || this.dataSource.selection.selected.length > 0;
  }

  isSelectedActionButtonVisible(): boolean {
    return this.authService.hasPermission(Permission.ManageAllExternalWorkersList)
      || this.authService.hasPermission(Permission.ManageMyExternalWorkersList)
      || this.authService.hasPermission(Permission.SendMultipleWorkerAgreementsToApproval)
  }


  createAgreementEndDateTooltipText(element: AllWorkerAgreementGridDto) {
    const datepipe: DatePipe = new DatePipe('en-US');

    let tooltipText = `${this.translateService.instant('AgreementEndDateForTooltip')}: ${datepipe.transform(element.AgreementEndDate, 'yyyy-MM-dd') || this.translateService.instant('AgreementIndefinitelyPeriod')}
    ${this.translateService.instant('TerminationSubmissionDate')}: ${datepipe.transform(element.AgreementTerminationSubmissionDate, 'yyyy-MM-dd')}
    ${this.translateService.instant('TerminationStartDate')}: ${datepipe.transform(element.AgreementTerminationStartDate, 'yyyy-MM-dd')}
    ${this.translateService.instant('AgreementTerminationEndDate')}: ${datepipe.transform(element.AgreementTerminationEndDate, 'yyyy-MM-dd')}`;

    if (!!element.LastDayOfWork) {
      tooltipText += `\n${this.translateService.instant('LastDayOfWork')}: ${datepipe.transform(element.LastDayOfWork, 'yyyy-MM-dd')}`
    }

    return tooltipText
  }

  private setFileName = (fullName: string): string => `Umowa ${fullName}.pdf`;

  private openAlertDialog = (message: string) =>
    this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
      },
    });

  private openConfirmDialog(message: string, title: string = null, confirmButtonLabel: string = null, dismissButtonLabel: string = null): Promise<boolean> {
    return firstValueFrom(this.dialog.open(ConfirmDialogComponent, {
      data: new ConfirmDialogData(title, message, confirmButtonLabel, dismissButtonLabel),
      panelClass: 'confirm-dialog'
    }).afterClosed());
  }

  private async getSelectedWorkersList(): Promise<any[]> {
    if (this.isAllSelected()) {
      return await firstValueFrom(
        this.workerAgreementService.getMultipleWorkerAgreementsActionSelectedWorkers(
          this.filters,
          this.sort?.active ?? this.defaultSortColumn,
          this.sort?.direction ?? this.defaultSortDirection
        )
      );
    }
    return selectWithoutDuplicates(this.dataSource.selection.selected);
  }

  private async getSelectedWorkerAgreementsList(): Promise<any[]> {
    if (this.isAllSelected()) {
      return await firstValueFrom(
        this.workerAgreementService.getMultipleWorkerAgreementsActionSelectedWorkerAgreementIds(this.filters)
      );
    }
    return selectWorkerAgreementsWithoutDuplicates(this.dataSource.selection.selected);
  }

  private getActualPage() {
    const start = this.viewport.getRenderedRange().start + 1;
    const end = this.viewport.getRenderedRange().end;

    const pageStart = Math.ceil(start / this.pageSize);
    const pageEnd = Math.ceil(end / this.pageSize);

    const pageMultiplier = pageEnd - pageStart + 1;

    let pageSize = this.pageSize * pageMultiplier;

    const page = Math.ceil(pageStart / pageMultiplier === 0 ? this.defaultPageSize : pageMultiplier);

    if (pageSize * page < end) {
      pageSize += Math.ceil((end - pageSize * page) / this.pageSize) * this.pageSize;
    }

    return { page, pageSize };
  }

  private initLangChanegeObserver() {
    this.translateService.onLangChange
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async () => {
        var { page, pageSize } = this.getActualPage();

        this.fetchData(page, pageSize);
        await this.getMultipleActionsConfig();
      });
  }

  async nextBatch(event) {
    if (!this.sticky) {
      this.sticky = true;
    }
    const buffer = 20;
    const range = this.viewport.getRenderedRange();
    const end = range.end;
    if (true) {
      if (!this.dataSource.isLoading && end + buffer > this.page * this.pageSize) {
        this.fetchData(++this.page);
      }
    }
  }

  private init() {
    if (this.dataSource) {
      return;
    }

    this.dataSource = new AllWorkerAgreementsGridDataSource(
      this.workerAgreementService,
      {
        viewport: this.viewport
      });

    this.offset$ = this.viewport.renderedRangeStream.pipe(
      map(() => -this.viewport.getOffsetToRenderedContentStart())
    );
  }

  trackBy(index: number, item: AllWorkerAgreementGridDto) {
    return `${item.AgreementId}${item.AgreementStatusId}${item.WorkerStatusId}${item.WorkerFormStatusId}`;
  }

  private fetchData(page?: number, pageSize?: number) {
    this.dataSource.fetchWorkerAgreements(
      page ?? this.page,
      pageSize ?? this.pageSize ?? this.defaultPageSize,
      this.sort?.active ?? this.defaultSortColumn,
      this.sort?.direction ?? this.defaultSortDirection,
      this.filters,
    );
  }

  private async getMultipleActionsConfig() {
    if (this.isAllSelected()) {
      this.multipleActionsConfig = await firstValueFrom(this.workerAgreementService.getMultipleWorkerAgreementsActionConfig(this.filters));
    }
    this.refreshExtensionAvailability();
  }

  private refreshExtensionAvailability(): void {
    this.extensionAvailability = getExtensionOnMultipleAgreementsAvailability(
      !!this.isAllSelected(),
      this.dataSource.selection.selected,
      this.multipleActionsConfig
    );
    this.extensionTooltip = this.extensionAvailability.enabled
      ? this.translateService.instant('ExtendMultipleAgreementsTooltip')
      : this.translateService.instant(this.extensionAvailability.reasonKey);
  }



  private resetData() {
    this.page = 1;
    this.dataSource.reset();
  }

  private checkViewportSize() {
    if (this.dataSource) {
      this.changeDetectorRef.detectChanges();
      this.viewport.checkViewportSize();
    }
  }

  private resizeOnDataLoaded() {
    this.dataSource.dataLoaded$.pipe(first()).subscribe(() => {
      this.resizableColumnService.onResize();
    });
  }

  getColumnWidth(column: string): number {
    return this.resizableColumnService.getColumnWidth(column);
  }

  private initListRefresher(): void {
    const institutions = this.authService.getInstitutionsArray();

    this.agreementsSignalR.connect()
      .then(() => Promise.allSettled(institutions.map(id => this.agreementsSignalR.joinInstitutionGroup(Number(id)))))
      .catch(() => { /* connection errors are handled by automatic reconnect */ });

    this.agreementsSignalR.invalidated$
      .pipe(
        filter((evt: AgreementsInvalidatedEvent) => this.shouldReloadOnInvalidation(evt)),
        auditTime(environment.realtimeRefreshThrottleMs ?? DEFAULT_REALTIME_REFRESH_THROTTLE_MS),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(async () => {
        const { page, pageSize } = this.getActualPage();
        this.fetchData(page, pageSize);
        await this.getMultipleActionsConfig();
      });

    this.agreementsSignalR.reconnected$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async () => {
        const { page, pageSize } = this.getActualPage();
        this.fetchData(page, pageSize);
        await this.getMultipleActionsConfig();
      });
  }

  private shouldReloadOnInvalidation(evt: AgreementsInvalidatedEvent): boolean {
    if (!evt) return false;
    return true;
  }
}
